import { Component, OnInit } from '@angular/core';
import { AdbookingService } from '../services/adbooking.service';
import { UserdataService } from '../services/userdata.service';
import { Router } from '@angular/router';
import { VieworderService } from '../services/vieworder.service';
import { OrderstatusService } from '../services/orderstatus.service';

@Component({
  selector: 'app-myorder',
  templateUrl: './myorder.component.html',
  styleUrls: ['./myorder.component.css']
})
export class MyorderComponent implements OnInit {
 email:any;
 orderdetails: object;
 orderid:any;
 user: { userdata: any; };
 
 router:Router
 searchorder: any;
 status: any;

  

  constructor(private bookingService: AdbookingService,private userdataservice: UserdataService,private Vieworderservice : VieworderService,private Orderstatusservice: OrderstatusService ) {
      
  }

  
  ngOnInit() {


    

     this.userdataservice.getUserDataSubject().subscribe(data => {
      this.email = data['email'];
      console.log(this.email);

      this.bookingService.getorder(this.email).subscribe(
        resp => {
          // console.log(resp);
           
            this.orderdetails = resp;
            console.log(this.orderdetails);
           
          
        });

    });
 
  }
  username(username: any) {
    throw new Error("Method not implemented.");
  }


  onSelect(selectedItem: any) {
    
    console.log("Selected item Id: ", selectedItem.orderid); // You get the Id of the selected item here
    this.orderid = selectedItem.orderid;
    this.Vieworderservice.setVieworderdata(this.orderid);

    console.log("Selected item Id: ", selectedItem.status); // You get the Id of the selected item here
    this.status = selectedItem.status;
    this.Orderstatusservice.setOrderstatus(this.status);
  }

  
click(){
  this.router.navigate(['/vieworder']);
}
}
